import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function CollapsibleTable(props: any) {
  const { rows, createData } = props;

  function scrollToComponent() {
    // Add a delay that matches the collapse animation duration
    setTimeout(() => {
      document?.getElementById("bottom")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300); // Adjust this timing based on the collapse animation duration
  }

  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          sx={{
            backgroundColor: "transparent",
          }}
        >
          <TableCell
            sx={{
              borderBottom: "none", // Remove default bottom border
            }}
          >
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                scrollToComponent();
                setOpen(!open);
              }}
              sx={{ color: "#03a9f4" }} // Set icon color
            >
              {open ? (
                <KeyboardArrowUpIcon sx={{ color: "#03a9f4" }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ color: "#03a9f4" }} />
              )}
            </IconButton>
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            sx={{ color: "white", borderBottom: "none" }} // Remove default bottom border
          >
            {row.title}
          </TableCell>
          <TableCell
            align="center"
            component="th"
            scope="row"
            sx={{ color: "white", borderBottom: "none" }} // Remove default bottom border
          >
            {row.required_count}
          </TableCell>
          {/* <TableCell
            align="center"
            component="th"
            scope="row"
            sx={{ color: "white", borderBottom: "none" }} // Remove default bottom border
          >
            {row.curriculum_version}
          </TableCell> */}
          <TableCell
            align="center"
            component="th"
            scope="row"
            sx={{ color: "white", borderBottom: "none" }} // Remove default bottom border
          >
            {row.option_group_credit}
          </TableCell>
        </TableRow>
        <TableRow
          sx={{ background: "#3C406C", boxShadow: "inset 0 0 5px black" }}
        >
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              borderBottom: "1px solid #3C406C",
            }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  sx={{ color: "white" }}
                >
                  Competencies in the Group
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                        }}
                      >
                        Competency Code
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                        }}
                      >
                        Title
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                        }}
                        align="right"
                      >
                        Credit
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.competencies.map((competency: any) => (
                      <TableRow key={competency.competency_code}>
                        <TableCell
                          sx={{ color: "white", borderBottom: "none" }}
                          component="th"
                          scope="row"
                        >
                          {competency.competency_code}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", borderBottom: "none" }}
                        >
                          {competency.title}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", borderBottom: "none" }}
                          align="right"
                        >
                          {competency.credits}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{ backgroundColor: "transparent", boxShadow: "none" }}
    >
      <Table
        aria-label="collapsible table"
        sx={{ backgroundColor: "transparent" }}
      >
        <TableHead sx={{ backgroundColor: "#090a14" }}>
          <TableRow>
            <TableCell sx={{ color: "white", borderBottom: "1px solid #3C406C" }} />
            {/* Empty cell for expand button */}
            <TableCell sx={{ color: "white", fontWeight: "bold", borderBottom: "1px solid #3C406C" }}>
              Title
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", borderBottom: "1px solid #3C406C" }}
              align="center"
            >
              Required Count
            </TableCell>
            {/* <TableCell
              sx={{ color: "white", fontWeight: "bold" }}
              align="center"
            >
              Curriculum Version
            </TableCell> */}
            <TableCell
              sx={{ color: "white", fontWeight: "bold", borderBottom: "1px solid #3C406C" }}
              align="center"
            >
              Option Group Credit
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody
        // sx={{ "& .MuiTableCell-root": { borderBottom: "1px solid #3C406C" } }}
        >
          {rows.map((row: any) => (
            <Row key={row?.title} row={row} />
          ))}
        </TableBody>
      </Table>
      <div id="bottom" />
    </TableContainer>
  );
}
